module.exports = __webpack_public_path__ + "img/P36.c3fad603.png";